import { getFilters } from "../../utils/commonUtils";
import { commonBaseApiSlice } from "../commonBaseApiSlice";

export const ndcWhitelistSetupApiSlice = commonBaseApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAthenaOrderList: builder.mutation({
      query: (data) => ({
        url: `/athenaordermaster/get?${getFilters(data)}`,
        method: "GET",
      }),
    }),
    getAthenaOrderNDCWhiteList: builder.mutation({
      query: (data) => ({
        url: `/athenaorderndcwhitelist/get?${getFilters(data)}`,
        method: "GET",
      }),
    }),
    searchAthenaOrders: builder.mutation({
      query: (data) => ({
        url: `/athena/searchorders?${getFilters(data)}`,
        method: "POST",
      }),
    }),
    upsertAthenaOrderNDCWhiteList: builder.mutation({
      query: (data) => ({
        url: `/athenaorderndcwhitelist/upsert`,
        method: "POST",
        body: data,
      }),
    }),
    upsertAthenaOrderMaster: builder.mutation({
      query: (data) => ({
        url: `/athenaordermaster/upsert`,
        method: "POST",
        body: data,
      }),
    }),
    deleteAthenaOrderNDCWhiteList: builder.mutation({
      query: (id: any) => ({
        url: `/athenaorderndcwhitelist/delete?id=${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useGetAthenaOrderListMutation,
  useGetAthenaOrderNDCWhiteListMutation,
  useSearchAthenaOrdersMutation,
  useUpsertAthenaOrderNDCWhiteListMutation,
  useUpsertAthenaOrderMasterMutation,
  useDeleteAthenaOrderNDCWhiteListMutation,
} = ndcWhitelistSetupApiSlice;
